import {
	CONTACTS_RECEIVED,
	FILTER_CONTACTS_IN_CATEGORIES,
	NEW_CONTACT_ADDED_STATUS,
	REMOVE_SELECTED_CONTACT,
	REMOVE_CONTACT_STATUS,
	VESSEL_CONTACT_PROFILE_IMG,
	UPDATE_CONTACT_FROM_LOCAL,
	UPDATE_CONTACT_FROM_ACCEPTED,
	UPDATE_IGNORED_CONTACT,
	SYNC_CONTACTS_WITH_CACHE,
	UPDATE_PENDING_CONTACTS,
	UPDATE_SELECTED_PENDING_CONTACT,
} from "../actions/contacts";
import {
	SELECTED_CONTACT,
	CLEAR_SELECTED_CONTACT,
	ADD_NEW_USER_ASSOCIATION,
} from "../actions/contacts";

import { CLEAR_ACCEPT_IGNORE_CONTACT, CONTACT_ACCEPTED, LOGOUT_USER, NEW_CONTACT_ACCEPT_IGNORE_MESSAGE__RECEIVED, TRACK_FAVORITE_ACTION_PROGRESS } from "../constants";


let initialState = {
	accepted: [],
	ignored: [],
	localContacts: [],
	domainContacts: [],
	shoreContacts: [],
	shipContacts: [],
	directoryContacts: [],
	pendingContacts: [],
	allContacts: [],
	vessels: [],
	error: null,
	selectedContact: {},
	selectedPendingContact: {},
	contactRemovingStatus: false,
	newContactCreatedStatus: false,
	vesselContactsProfileImages: {},
	isDataLoaded: true,
	usersAssociation: {},
	contentList : []
};

function contactsReducer(state = initialState, action) {
	switch (action.type) {
		case CONTACTS_RECEIVED:
			let usersAssociation = {};
			action.data.accepted.forEach((contact) => {
				usersAssociation[contact.userId] = contact.userName;
			});
			action.data.ignored.forEach((contact) => {
				usersAssociation[contact.userId] = contact.userName;
			});
			action.data.localContacts.forEach((contact) => {
				usersAssociation[contact.userId] = contact.userName;
			});
			action.data?.domainContacts?.forEach((contact) => {
				usersAssociation[contact.userId] = contact.userName;
			});

			return {
				...state,
				accepted: action.data.accepted,
				ignored: action.data.ignored,
				localContacts: action.data.localContacts,
				domainContacts: action.data.domainContacts,
				vessels: action.data.vessels,
				pendingContacts: action.data.pendingContacts,
				directoryContacts: action.data.directoryContacts,
				shipContacts: action.data.shipContacts,
				shoreContacts: action.data.shoreContacts,
				allContacts: action.data.allContacts,
				usersAssociation,
				isDataLoaded: false,
				contentList: action.data.contentList || []
			};
		case ADD_NEW_USER_ASSOCIATION:
			let usersAssociationNew = state.usersAssociation;
			usersAssociationNew[action.data.userId] = action.data.userName;
			return { ...state, usersAssociation: usersAssociationNew };
		case UPDATE_CONTACT_FROM_LOCAL:
			return { ...state, localContacts: action.data };
		case UPDATE_CONTACT_FROM_ACCEPTED:
			return { ...state, accepted: action.data };
		case UPDATE_IGNORED_CONTACT:
			return { ...state, ignored: action.data };

		case VESSEL_CONTACT_PROFILE_IMG:
			return {
				...state,
				vesselContactsProfileImages: action.data.vesselContactsProfileImages,
			};

		case SELECTED_CONTACT:
			return {
				...state,
				selectedContact: { ...action.data },
			};
		case REMOVE_SELECTED_CONTACT:
			return {
				...state,
				selectedContact: { ...initialState.selectedContact },
			};
		case REMOVE_CONTACT_STATUS:
			return {
				...state,
				contactRemovingStatus: action.contactRemovingStatus,
				newContactCreatedStatus: !action.contactRemovingStatus,
			};
		case NEW_CONTACT_ADDED_STATUS:
			return {
				...state,
				newContactCreatedStatus: action.newContactCreatedStatus,
				contactRemovingStatus: !action.newContactCreatedStatus,
			};
		case LOGOUT_USER:
			return { ...initialState };

		case CLEAR_SELECTED_CONTACT:
			return {
				...state,
				selectedContact: { ...initialState.selectedContact },
			};

		case NEW_CONTACT_ACCEPT_IGNORE_MESSAGE__RECEIVED: {
			const message = action.data.message.message;
			const accepted = state.accepted;
			const newContactRequest = { ...message, showAcceptIgnoreMsg: true };
			const acceptedUpdated = [...accepted, newContactRequest];
			return {
				...state,
				accepted: acceptedUpdated,
			};
		}
		case CLEAR_ACCEPT_IGNORE_CONTACT:
			return { ...state, acceptIgnoreContact: null };
		case CONTACT_ACCEPTED: {
			const contactRcvd = action.data.message.message;
			const tempAccepted = [...state.accepted];
			let indexOfAcceptedContact = -1;
			for (let i = 0; i < tempAccepted.length; i++) {
				if (tempAccepted[i].userId === contactRcvd.userId) {
					indexOfAcceptedContact = i;
					break;
				}
			}
			if (indexOfAcceptedContact === -1) {
				return {
					...state,
					accepted: [...state.accepted, contactRcvd],
				};
			} else {
				tempAccepted[indexOfAcceptedContact] = contactRcvd;
				return {
					...state,
					accepted: tempAccepted,
				};
			}
		}
		case SYNC_CONTACTS_WITH_CACHE:
			return {
				...state,
				...action.data,
			};
		case TRACK_FAVORITE_ACTION_PROGRESS:
			{
				const tempAccepted = state.accepted?.map(accp_contact => {
					if (accp_contact.userId === action.data.userId) {
						return {
							...accp_contact,
							favActionInProgress: action.data.startAction
						}
					} else {
						return accp_contact
					}
				})
				return {
					...state,
					accepted: tempAccepted,
					selectedContact: { ...state.selectedContact, favActionInProgress: action.data.startAction }
				};
			};

		case FILTER_CONTACTS_IN_CATEGORIES:
			return {
				...state,
				directoryContacts: action.data.directoryContacts,
				shipContacts: action.data.shipContacts,
				shoreContacts: action.data.shoreContacts,
				allContacts: action.data.allContacts,
				isDataLoaded: false,
			}

		case UPDATE_PENDING_CONTACTS:
			return {
				...state,
				pendingContacts: action.data.pendingContacts
			}

		case UPDATE_SELECTED_PENDING_CONTACT:
			return {
				...state,
				selectedPendingContact: action.data.contact,
			}

		default:
			return state;
	}
}

export default contactsReducer;
